var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowing)?_c('div',{ref:"interactElement",staticClass:"card container",class:{
    isAnimating: _vm.isInteractAnimating,
    isCurrent: _vm.isCurrent
  },style:({ transform: _vm.transformString })},[_c('img',{staticStyle:{"width":"90%","height":"90%"},attrs:{"src":_vm.card}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }